<div class="cp" [class.is-open]="expanded">
  <div class="cp-row">
    <span class="cp-avatar">
      @if (avatar) {
        <img [src]="avatar" alt="" />
      } @else {
        {{ initials }}
      }
    </span>
    <textarea #box class="cp-text" [(ngModel)]="text" [rows]="expanded ? 3 : 1" [placeholder]="placeholder"
      aria-label="Write a post" maxlength="5000" (focus)="focused = true"></textarea>
  </div>

  @if (expanded) {
    <div class="cp-extras">
      @if (showLabel) {
        <input class="cp-label" type="text" maxlength="40" autocomplete="off" [(ngModel)]="label"
          aria-label="Post label" placeholder="Label, e.g. Session recap, Loot drop, Question" />
      }
      <app-social-attachment-preview [picker]="attachment"></app-social-attachment-preview>
      @if (attachment.error) {
        <p class="cp-error">{{ attachment.error }}</p>
      }
      <app-social-poll-composer [draft]="poll"></app-social-poll-composer>
    </div>
  }

  <div class="cp-bar">
    <div class="cp-tools">
      @if (!poll.open) {
        <label class="cp-tool" title="Photos or a video" aria-label="Add photos or a video">
          <i class="fa fa-image"></i>
          <input type="file" accept="image/*,video/*" multiple hidden (change)="onFile($event)" />
        </label>
      }
      @if (!attachment.file) {
        <button type="button" class="cp-tool" [class.is-on]="poll.open" [attr.aria-pressed]="poll.open" (click)="poll.toggle(); focused = true" title="Add a poll" aria-label="Add a poll">
          <i class="fa fa-bar-chart"></i>
        </button>
      }
      <button type="button" class="cp-tool" [class.is-on]="showLabel" [attr.aria-pressed]="showLabel" (click)="showLabel = !showLabel; focused = true" title="Add a label" aria-label="Add a label">
        <i class="fa fa-tag"></i>
      </button>
      <app-social-emoji-picker [target]="box"></app-social-emoji-picker>
    </div>

    <div class="cp-send">
      @if (!target) {
        <ng-select class="wt-select cp-target" [(ngModel)]="picked" [items]="targetOptions" bindValue="value" bindLabel="label"
          groupBy="group" [clearable]="false" [searchable]="false" appendTo="body" aria-label="Post to"></ng-select>
      }
      <button type="button" class="btn btn-theme cp-post" [disabled]="!canPost" (click)="publish()">
        {{ posting ? 'Posting…' : 'Post' }}
      </button>
    </div>
  </div>
</div>
